import Vue from 'vue';
import VueRouter from 'vue-router';


Vue.use(VueRouter);
// 1. 定义 (路由) 组件。
// 可以从其他文件 import 进来

import index from "../../components/index";

import classBook from "../../components/class";

import book from "../../components/bookCon";

import search from "../../components/search";

import my from "../../components/my";

import collected from "../../components/my/collected";

import listenHistory from "../../components/my/history";

import noBook from "../../components/my/noBook";

import audienceInfo from "../../components/my/audienceInfo";

import logout from "../../components/my/logout";

import resetUser from "../../components/my/resetUser";

import login from "../../components/loginTwo";

import statistics from "../../components/statistics";


// 2. 定义路由
// 每个路由应该映射一个组件。 其中"component" 可以是
// 通过 Vue.extend() 创建的组件构造器，
// 或者，只是一个组件配置对象。
const routes = [
    {
        path: '/',
        name: 'index',
        component: index
    },
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/statistics',
        name: 'statistics',
        component: statistics
    },
    {
        path: '/classBook',
        name: 'classBook',
        component: classBook
    },
    {
        path: '/book',
        name: 'book',
        component: book
    },
    {
        path: '/search',
        name: 'search',
        component: search
    },
    {
        path: '/my',
        name: 'my',
        component: my,
        children: [
            {
                path: 'collected',
                name: 'collected',
                component: collected,
            },
            {
                path: 'listenHistory',
                name: 'listenHistory',
                component: listenHistory,
            },
            {
                path: 'noBook',
                name: 'noBook',
                component: noBook,
            },
            {
                path: 'audienceInfo',
                name: 'audienceInfo',
                component: audienceInfo,
            },
            {
                path: 'resetUser',
                name: 'resetUser',
                component: resetUser,
            },
            {
                path: 'logout',
                name: 'logout',
                component: logout,
            },
        ]
    },
]

export const router = new VueRouter({
    mode: 'history',
    // base: "/headset/",
    routes // (缩写) 相当于 routes: routes
})